import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";

export default function DiseaseCards() {
  return (
    <div>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="6" style={{marginBottom: "60px"}}>
            <h2 className="title">Verticals Served</h2>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Card
              data-background="image"
              style={{
                backgroundImage:
                  "url(" +
                  require("assets/img/sections/pavel-kosov.jpg").default +
                  ")",
              }}
            >
              <CardBody>
                <h6 className="card-category">Cancer</h6>
                {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <CardTitle tag="h3">The Best Productivity Apps</CardTitle>
                </a> */}
                <p className="card-description">
                  Don't be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves
                  Kanye I love Rick Owens’ bed design but the back is...
                </p>
                <br />
                {/*<Button*/}
                {/*  className="btn-round"*/}
                {/*  color="danger"*/}
                {/*  href="#pablo"*/}
                {/*  onClick={(e) => e.preventDefault()}*/}
                {/*>*/}
                {/*  <i className="fa fa-book mr-1" />*/}
                {/*  Read Article*/}
                {/*</Button>*/}
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card
              data-background="image"
              style={{
                backgroundImage:
                  "url(" +
                  require("assets/img/sections/pavel-kosov.jpg").default +
                  ")",
              }}
            >
              <CardBody>
                <h6 className="card-category">Covid-19</h6>
                {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <CardTitle tag="h3">The Best Productivity Apps</CardTitle>
                </a> */}
                <p className="card-description">
                  Don't be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves
                  Kanye I love Rick Owens’ bed design but the back is...
                </p>
                <br />
                {/*<Button*/}
                {/*  className="btn-round"*/}
                {/*  color="danger"*/}
                {/*  href="#pablo"*/}
                {/*  onClick={(e) => e.preventDefault()}*/}
                {/*>*/}
                {/*  <i className="fa fa-book mr-1" />*/}
                {/*  Read Article*/}
                {/*</Button>*/}
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card
              data-background="image"
              style={{
                backgroundImage:
                  "url(" +
                  require("assets/img/sections/pavel-kosov.jpg").default +
                  ")",
              }}
            >
              <CardBody>
                <h6 className="card-category">Alzheimer</h6>
                {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <CardTitle tag="h3">The Best Productivity Apps</CardTitle>
                </a> */}
                <p className="card-description">
                  Don't be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves
                  Kanye I love Rick Owens’ bed design but the back is...
                </p>
                <br />
                {/*<Button*/}
                {/*  className="btn-round"*/}
                {/*  color="danger"*/}
                {/*  href="#pablo"*/}
                {/*  onClick={(e) => e.preventDefault()}*/}
                {/*>*/}
                {/*  <i className="fa fa-book mr-1" />*/}
                {/*  Read Article*/}
                {/*</Button>*/}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
